<template>
  <div class="comment-item">
    <img :src="obj.head_portrait" alt="" class="avatar" />
    <div class="comm-con">
      <div class="username">{{ obj.nickname }}</div>
      <div class="time">{{ obj.created_at }}</div>
      <div class="con-text">{{ obj.comment }}</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    obj: Object,
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.comment-item {
  font-size: 15px;
  display: flex;
  align-items: flex-start;
  margin-bottom: 40px;
  .avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-right: 20px;
    object-fit: cover;
  }
  .comm-con {
    .username {
      font-size: 16px;
      margin-bottom: 10px;
      color: #815a4e;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .time {
      font-size: 14px;
      color: #999;
      margin-bottom: 10px;
    }
    .con-text{
      line-height: 1.5;
      font-size: 15px;
    }
  }
}
</style>
